module.exports = __webpack_public_path__ + "static/media/mobile03_01.31ffe353.png";